// src/utils/toast.tsx

/** @jsx createElement */
import { createElement } from "./jsx.ts";

import { id } from "./id.ts";
import { IconX } from "../modules/icons/ui/IconX.tsx";

const LIFE_SPAN = 5 * 1000;
const TOAST_ID = id();

export const showToast = ({ message, variant }: { variant: "info" | "error"; message: string }) => {
  document.getElementById(TOAST_ID)?.remove();

  const toast = (
    <div id={TOAST_ID} class="toast" data-variant={variant}>
      <p>{message}</p>
      <button class="close-button" onclick={() => toast.remove()}>
        {IconX()}
      </button>
    </div>
  );

  setTimeout(() => {
    toast?.remove();
  }, LIFE_SPAN);

  document.body.appendChild(toast);
};

export const hideToast = () => {
  document.getElementById(TOAST_ID)?.remove();
};
